import { Field } from 'formik';
import { useIntl } from 'react-intl';
import { FieldProps } from '../../types/fields';
import { config } from '../../utils/config';
import getValidator from '../../utils/getValidator';
import TextField from '../formik/TextField';

const NamesField = (props: FieldProps & { fieldContainerClassName?: string }) => {
  const { formatMessage } = useIntl();
  const { context, testIdPrefix } = props;
  const { firstName, lastName } = config.names;
  const fieldContainerClassName = props.fieldContainerClassName ?? 'form__field-container';

  const lastNameField = (
    <div className={fieldContainerClassName}>
      <Field
        name={[context, 'lastName'].filter(Boolean).join('.')}
        component={TextField}
        label={formatMessage({ id: 'generic.lastName' })}
        maxLength={lastName.maxLength}
        validate={getValidator({ ...lastName, required: true })}
        data-test-id={`${testIdPrefix}-lastName`}
        autoComplete="family-name"
      />
    </div>
  );

  return (
    <>
      {lastName.position === 'first' && lastNameField}
      <div className={fieldContainerClassName}>
        <Field
          name={[context, 'firstName'].filter(Boolean).join('.')}
          component={TextField}
          label={formatMessage({ id: 'generic.firstName' })}
          maxLength={firstName.maxLength}
          validate={getValidator({ ...firstName, required: true })}
          data-test-id={`${testIdPrefix}-firstName`}
          autoComplete="given-name"
        />
      </div>
      {lastName.position === 'second' && lastNameField}
    </>
  );
};

export default NamesField;
